import ConfigUtils from "qwc2/utils/ConfigUtils";
import {LayerRole} from "qwc2/actions/layers";
import LayerUtils from "qwc2/utils/LayerUtils";
import axios from "axios";
import clientAuth from "../ClientAuth";
import {UrlParams} from "qwc2/utils/PermaLinkUtils";

const AppStateUtils = {

    generatePermaLink(state, callback, user = false) {
        if (!ConfigUtils.getConfigProp("permalinkServiceUrl")) {
            callback(window.location.href);
            return;
        }
        const permalinkState = {};
        if (ConfigUtils.getConfigProp("storeAllLayersInPermalink")) {
            permalinkState.layers = state.layers.flat.filter(layer => layer.role !== LayerRole.BACKGROUND);
        } else {
            // Only store redlining layers
            const exploded = LayerUtils.explodeLayers(state.layers.flat.filter(layer => layer.role !== LayerRole.BACKGROUND));
            const redliningLayers = exploded.map((entry, idx) => ({...entry, pos: idx}))
                .filter(entry => entry.layer.role === LayerRole.USERLAYER && entry.layer.type === 'vector')
                .map(entry => ({...entry.layer, pos: entry.pos}));
            permalinkState.layers = redliningLayers;
        }

        const search = location.search.substring(1);
        const query = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) {
            return key === "" ? value : decodeURIComponent(value)
        });
        const post = {
            query: query,
            state: permalinkState
        };

        // const route = user ? "userpermalink" : "createpermalink";
        axios.post(ConfigUtils.getConfigProp("permalinkServiceUrl").replace(/\/$/, '') + "/", post, clientAuth.headers())
            .then(response => callback(response))
            .catch(() => callback(null));
    },

    resolvePermaLink(initialParams, callback) {
        const key = UrlParams.getParam('k');
        if (key) {
            axios.get(ConfigUtils.getConfigProp("permalinkServiceUrl").replace(/\/$/, '') + "/" + key)
                .then(response => {
                    callback({...initialParams, ...(response.data.query || {})}, response.data.state || {});
                })
                .catch(() => {
                    callback(initialParams, {});
                });
        } else {
            callback(initialParams, {});
        }
    }

};

export default AppStateUtils;
